<template>
  <div>
    <div class="bg-white py-6">
      <!-- Replace with your content -->
      <div>
        <div class="md:flex md:items-center md:justify-between sm:px-6 md:px-8">
          <div class="flex-1 min-w-0">
            <h2
              class="text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate"
            >
              {{ $t("messages.gameRankingReport.rankingReport") }}
            </h2>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4"></div>
        </div>
      </div>
    </div>
    <!-- /End replace -->

    <nav
      class="bg-white border-b border-t border-gray-200 flex"
      aria-label="Breadcrumb"
    >
      <ol class="w-full mx-auto px-4 flex space-x-4 sm:px-6 md:px-8">
        <li class="flex">
          <div class="flex items-center">
            <a
              href="javascript:void(0)"
              class="text-gray-400 hover:text-gray-500"
            >
              <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
              <span class="sr-only">Home</span>
            </a>
          </div>
        </li>
        <li v-for="page in pages" :key="page.name" class="flex">
          <div class="flex items-center">
            <svg
              class="flex-shrink-0 w-6 h-full text-gray-200"
              viewBox="0 0 24 44"
              preserveAspectRatio="none"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <router-link
              :to="page.href"
              class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :aria-current="page.current ? 'page' : undefined"
              >{{ page.name }}</router-link
            >
          </div>
        </li>
      </ol>
    </nav>

    <div class="">
      <div
        class="space-y-8 divide-y divide-gray-200 bg-white py-3 border-b text-center"
      >
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 px-2 flex justify-center lg:ml-6 lg:justify-start">
            <Listbox as="div" v-model="selected">
              <div class="relative w-48">
                <ListboxButton
                  class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  <span class="block truncate">{{ selected.label }}</span>
                  <span
                    class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                  >
                    <SelectorIcon
                      class="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </span>
                </ListboxButton>

                <transition
                  leave-active-class="transition ease-in duration-100"
                  leave-from-class="opacity-100"
                  leave-to-class="opacity-0"
                >
                  <ListboxOptions
                    class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                  >
                    <ListboxOption
                      as="template"
                      v-for="month in months"
                      :key="month.label"
                      :value="month"
                      @click="search(month)"
                    >
                      <li
                        :class="[
                          'hover:text-white hover:bg-indigo-600 text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9',
                        ]"
                      >
                        <span
                          :class="[
                            selected.value == month.value
                              ? 'font-semibold'
                              : 'font-normal',
                            'block truncate text-left',
                          ]"
                        >
                          {{ month.label }}
                        </span>

                        <span
                          v-if="selected.value == month.value"
                          :class="[
                            'absolute inset-y-0 right-0 flex items-center pr-4 pl-5',
                          ]"
                        >
                          <CheckIcon class="h-5 w-5" aria-hidden="true" />
                        </span>
                      </li>
                    </ListboxOption>
                  </ListboxOptions>
                </transition>
              </div>
            </Listbox>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8">
            <button
              type="button"
              @click="exports()"
              class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
            >
              <font-awesome-icon class="mr-2" :icon="['far', 'file-export']" />
              {{ $t("messages.gameRankingReport.exportReport") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="px-8 py-6" v-show="!isLoaded">
      <div
        class="space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center"
      >
        <font-awesome-icon
          class="text-gray-500"
          :icon="['fas', 'circle-notch']"
          transform="grow-6"
          spin
        />
      </div>
    </div>

    <div class="py-6" v-if="isLoaded">
      <div class="px-4">
        <div class="bg-white shadow overflow-auto sm:rounded-md">
          <div class="">
            <div class="p-6" v-for="(data, type) in dataRows" :key="type">
              <h2 class="uppercase text-sm font-bold">{{ type }}</h2>
              <div class="grid-ranking--row">
                <div
                  class="w-full"
                  :class="header"
                  v-for="(item, header, index) in data"
                  :key="header"
                >
                  <RankingTable
                    :class="header"
                    :tableHeader="header"
                    :tableType="type"
                    :dataRows="data"
                  ></RankingTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
} from "@heroicons/vue/solid";
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { inject, onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";
import RankingTable from "@/components/tables/RankingTable.vue";

dayjs.extend(localizedFormat);

const pages = [{ name: "Ranking Report", href: "", current: true }];

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    SelectorIcon,
    RankingTable,
  },
  setup() {
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const toDate = ref("");

    const startDate = dayjs();
    const diff = startDate.diff("2021-07-01", "months");
    let months = ref([]);

    for (let i = 0; i <= diff; i++) {
      months.value.push({
        label: dayjs("2021-07-01").add(i, "month").format("MM/YYYY"),
        value: dayjs("2021-07-01").add(i, "month").format(),
      });
    }

    const selected = ref(months.value[months.value.length - 1]);

    let dataRows = ref([]);
    let dataCount = ref(0);
    let isLoaded = ref(false);

    onMounted(() => {
      refetch();
    });

    const refetch = () => {
      let fromParams = dayjs(selected.value.value).startOf("month").format();
      let toParams = dayjs(selected.value.value).endOf("month").format();

      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
            "/admin/api/v1/report/game-ranking-op",
          null,
          {
            params: {
              operatorId: store.state.selectedOperator.operatorId,
              from: fromParams,
              to: toParams,
            },
          }
        )
        .then(({ data }) => {
          dataRows.value = data.result;
          dataCount.value = 0;
          isLoaded.value = true;
        })
        .catch(({ response }) => {
          console.log(response.data);
        });
    };

    const search = (month) => {
      let from = dayjs(month.value);
      let fromParams = dayjs(month.value).startOf("month").format();
      let toParams = dayjs(month.value).endOf("month").format();

      if (from.isValid()) {
        isLoaded.value = false;
        axios
          .post(
            process.env.VUE_APP_API_ENDPOINT +
              "/admin/api/v1/report/game-ranking-op",
            null,
            {
              params: {
                operatorId: store.state.selectedOperator.operatorId,
                from: fromParams,
                to: toParams,
              },
            }
          )
          .then(({ data }) => {
            dataRows.value = data.result;
            dataCount.value = 0;
            isLoaded.value = true;
          })
          .catch((err) => {
            console.log(err);
            isLoaded.value = true;
          });
      }
    };

    const prev = () => {
      if (route.query.page && route.query.page !== "1") {
        router
          .push({
            query: {
              page: parseInt(route.query.page) - 1,
            },
          })
          .then(() => {
            refetch();
          });
      }
    };

    const next = () => {
      router
        .push({
          query: {
            page: parseInt(route.query.page) + 1 || 2,
          },
        })
        .then(() => {
          refetch();
        });
    };

    const viewData = (data) => {
      router.push({ name: "Wallet Info", params: { id: data.id } });
    };

    const exports = () => {
      let fromParams = dayjs(selected.value.value).startOf("month").format();
      let toParams = dayjs(selected.value.value).endOf("month").format();
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
            "/admin/api/v1/report/export/game-ranking-op",
          null,
          {
            params: {
              operatorId: store.state.selectedOperator.operatorId,
              from: fromParams,
              to: toParams,
            },
          }
        )
        .then(({ data }) => {
          window.open(data.result);
        });
    };

    return {
      dataRows,
      dataCount,
      isLoaded,
      dayjs,
      selected,
      toDate,
      route,
      prev,
      next,
      search,
      viewData,
      months,
      pages,
      exports,
    };
  },
};
</script>

<style scoped lang="scss">
.grid-ranking--row {
  padding: 1rem;
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas:
    "today  week "
    "month month ";
  gap: 1rem;

  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "today   "
      "week"
      "month  ";
  }

  .today {
    grid-area: today;
  }
  .week {
    grid-area: week;
  }
  .month {
    grid-area: month;
  }

  .month,
  .week,
  .today {
    margin: 1rem;
  }

  // @media only screen and (max-width: 1400px) {
  //   grid-template-rows: 1fr 1fr;
  //   grid-template-columns: 1fr 1fr;
  //   .month {
  //     grid-column: 1/3;
  //   }
  // }
  // @media only screen and (max-width: 550px) {
  //   grid-template-columns: 1fr;
  //   grid-template-rows: 1fr 1fr 1fr;
  //   .month {
  //     grid-column: 1/2;
  //   }
  // }
}
</style>
